import isEmpty from 'lodash/isEmpty'
import sift from 'sift'

// Checks a created subscription item against the table's current column and search conditions.
// The conditions are JSON-normalized first so a Date-valued condition compares as the same
// ISO-8601 string the item carries. A condition on a field the list query does not select
// never matches, so that row stays out until the next fetch picks it up.
export const matchesTableConditions = (item: Record<string, any>, tableFilter?: Record<string, any>): boolean => {
  if (isEmpty(tableFilter?.$and)) return true
  return sift({ $and: JSON.parse(JSON.stringify(tableFilter.$and)) })(item)
}
